module.exports = __webpack_public_path__ + "static/img/primary-mobile.788d2bed.png";